// removed by extract-text-webpack-plugin
module.exports = {"mask":"_6hOvrzbkgPOkXw_4H4lB5","transparent":"_1l1g8PDbUoI4ssvrQ856dB","loader":"_9WJ7l1cvdI4AFBCK90SVL","circular":"_2GhabjaXr9eSokvcHKFH0W","rotate":"QwjGgX41LQJWHlrmKy_P0","path":"DHt2Fv39zX0mDGZ_ibADg","dash":"flTmVNUC08P1M6Bwr-jae","colored":"_3uSuAiZ5bbmGFfCZLGao1V","color":"lqIK1GSfwvqGIFm6kdMmd","inline":"mYLdUF8u8HAdE9ezAnIU7","left":"Occ_BiBDCw15AewR0yaID","center":"_3jDtnbVp8DMrEf5j1zph_e","right":"_2CJaQsSmLiSQNvrev3xQ6_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.scss
// module id = 1279
// module chunks = 1